import { render } from "./CorporateIdentity.vue?vue&type=template&id=4c873634&scoped=true"
import script from "./CorporateIdentity.vue?vue&type=script&lang=js"
export * from "./CorporateIdentity.vue?vue&type=script&lang=js"

import "./CorporateIdentity.vue?vue&type=style&index=0&id=4c873634&scoped=true&lang=scss"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c873634"]])

export default __exports__